import { Container } from '@joinrepublic/dls-ui-kit';

import { containerSize } from '../../config/styles';
import { BusinessCase } from '../business-case/business-case';
import { InteractiveMarquee } from '../interactive-marquee/interactive-marquee';
import { MotionBox } from '../motion-box/motion-box';
import { BUSINESS_CASES } from './data';

export const BusinessCases = () => {
  return (
    <Container
      as="section"
      id="business-cases"
      maxW={containerSize}
      my={{ base: '10', sm: '6' }}
      px={{ base: '0', sm: '4' }}
    >
      <MotionBox effect="fadeIn">
        <InteractiveMarquee spacing="4" delay={0.2}>
          {BUSINESS_CASES.map((businessCase) => (
            <BusinessCase
              key={businessCase.company}
              businessCase={businessCase}
            />
          ))}
        </InteractiveMarquee>
      </MotionBox>
    </Container>
  );
};
